import { FullCalendarEvent } from '../hooks/useReservableCalendarView';

type MultiFilterType = { label: string; value: string };

type FilterOptions = {
  selectedTags: MultiFilterType[];
  searchTerm: string;
};

export function filterMonthEventsByTagsAndSearch(
  events: FullCalendarEvent[],
  { selectedTags, searchTerm }: FilterOptions
): FullCalendarEvent[] {
  const tagSet = new Set(selectedTags.map(tag => tag.value));
  const term = searchTerm.toLowerCase().trim();

  return events.filter(event => {
    const tags = event.extendedProps.tags ?? [];
    const tagMatch = tagSet.size === 0 || tags.some(tag => tagSet.has(tag));

    if (!tagMatch) {
      return false;
    }

    if (term.length === 0) {
      return true;
    }

    const reservableName = (
      event.extendedProps.reservableName ?? ''
    ).toLowerCase();
    const title = (event.title ?? '').toLowerCase();

    return reservableName.includes(term) || title.includes(term);
  });
}
